import React from 'react';
import { CssBaseline, Box, Container } from "@mui/material";
//import QuestionCard from "./QuestionCard";
import Result from "./Result";

function MainQuiz() {
  const {questions} = props;  
  const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
  const [answers, setAnswers] = React.useState([]);
  const finishedQuiz = currentQuestionIndex === questions.length;
  const currentQuestion = questions[currentQuestionIndex];
  //console.log(currentQuestion)

  const goToNext = () => {
    setCurrentQuestionIndex((prevState) => prevState + 1);
  }

  const submitAnswer = (value) => {
    setAnswers((prevState) => [...prevState, value]);
    goToNext();
  }

  const restartQuiz = () => {
    setCurrentQuestionIndex(0);
    setAnswers([]);
  }

  return (
    <Box
      sx={{
        backgroundColor: 'primary.dark',
        minHeight: '100%',
        color: 'text.primary',
        py: 3
      }}
    >  
        {/* <Container maxWidth="sm"> */}
          {finishedQuiz ? <Result restartQuiz={restartQuiz} answers={answers} questions={questions}/> : ""
            }

        {/* </Container> */}
  </Box>
  );
}

export default MainQuiz;